import * as React from 'react';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { mapMessageTileToBannerProps } from '../../../common/banners/activity-message-banner-helper';
import { PlaceholderCards } from '../../../../components/srp/modules/module-components';
import { ActivityMessageBanner } from '../../../../components/common/banners/activity-message-banner';
import { ActivityDestinationViewSearch } from '../../../../common/__generated__/api';
import { ActivityTileCard } from './simple-result-card';

export interface GridLayoutResultsCardProps {
  activityTiles: ActivityDestinationViewSearch.ActivityTiles[];
  loading: boolean;
  onClick: (activity: ActivityDestinationViewSearch.ActivityInlineFragment, index: number) => void;
  activityGroup?: string;
}

export const GridLayoutComponent: React.FC<GridLayoutResultsCardProps> = ({
  activityTiles,
  loading,
  onClick,
  activityGroup
}): JSX.Element => {
  if (loading) {
    return <PlaceholderCards />;
  }

  const getGridViewTile = (
    activityTile: ActivityDestinationViewSearch.ActivityTiles,
    index: number
  ): JSX.Element | null => {
    switch (activityTile.__typename) {
      case 'Activity':
        return (
          <UitkLayoutGridItem key={`activity-tile-card-${index}`}>
            <ActivityTileCard
              activity={activityTile}
              loading={false}
              index={index}
              onClick={(): void => onClick(activityTile, index)}
              activityGroup={activityGroup}
            />
          </UitkLayoutGridItem>
        );
      case 'ActivityMessageTile':
        return (
          <UitkLayoutGridItem colSpan="all" key={`activity-message-card-${index}`}>
            <ActivityMessageBanner
              {...mapMessageTileToBannerProps(
                activityTile as ActivityDestinationViewSearch.ActivityMessageTileInlineFragment
              )}
            />
          </UitkLayoutGridItem>
        );
      default:
        return null;
    }
  };

  const renderGridLayoutView = (): JSX.Element => (
    <UitkLayoutGrid columns={{ small: 2, medium: 3, large: 3 }} tag="ul" space="three" alignContent="space-between">
      {activityTiles && activityTiles.map((activityTile, index) => getGridViewTile(activityTile, index))}
    </UitkLayoutGrid>
  );

  return renderGridLayoutView();
};
